// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 67) return "assets/js/vendor/67.js";
	if (chunkId === 309) return "assets/js/vendor/309.js";
	// return url for filenames based on template
	return undefined;
};